<template>
    <div class="mx-auto mb-3 bg-white p-3 rounded" style="width: 87%;">
        <div class="row">
        <div class="col-lg-6">
            <button type="button" :class="model == 0 ? 'btn-primary' : 'btn-light'" class="btn btn-block btn-lg" @click="onChange(0)">Buscar por tracking </button>
        </div>
        <div class="col-lg-6">
            <button type="button" :class="model == 1 ? 'btn-primary' : 'btn-light'" class="btn btn-block btn-lg" @click="onChange(1)">Busqueda avanzada</button>
        </div>
        </div>
    </div>
</template>
<script>
export default {
  computed: {
    model: {
      get () {
        return this.$attrs.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    onChange: function (val) {
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Option.vue